import React from 'react'
import theme from './_theme'
import Helmet from 'react-helmet'

import { createGlobalStyle, ThemeProvider } from 'styled-components'

const GlobalStyles = createGlobalStyle`

  @import url('https://fonts.googleapis.com/css?family=Open+Sans|Slabo+27px');

  *{
    box-sizing:border-box;
  }
  body{
    margin:0;
    background:${props => props.theme.pageBackgroundColor};
    font-family:${props => props.theme.fontFamily};
    line-height: 1.5;
    a{
      color:${props => props.theme.linkColor};
    }
  }
  #___gatsby > div > div{
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
`

export const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>
    <div>
      <Helmet>
        <link rel='stylesheet' href='https://use.fontawesome.com/releases/v5.7.1/css/all.css' integrity='sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr' crossOrigin='anonymous' />
      </Helmet>
      <GlobalStyles />
      { children }
    </div>
  </ThemeProvider>
)
